import { inject, Injectable } from '@angular/core';

import { BodyService } from '../body/body.service';
import { environment } from 'src/environments/environment';
import { ViewerDocument } from '../../types/viewer-document';

const BASE_URL = `${environment.service.url}/api`;

@Injectable({
  providedIn: 'root'
})
export class ViewerService {

  private readonly _bodyService: BodyService = inject(BodyService);

  private _isOpen: boolean = false;
  private _isClosing: boolean = false;
  private _document?: ViewerDocument = undefined;

  public get isOpen(): boolean {
    return this._isOpen;
  }

  public get isClosing(): boolean {
    return this._isClosing;
  }

  public get isImage(): boolean {
    return (this._document?.fileExtension !== '.jpg' && this._document?.fileExtension !== '.png' && this._document?.fileExtension !== '.jpeg') ? false : true;
  }

  public get document(): ViewerDocument | undefined {
    return this._document;
  }

  /**
   * Open viewer for Documents.
   * @param document Document model.
   */
  public view(document: ViewerDocument): void {
    this._document = document;
    this._isOpen = true;
    this._bodyService.blockBody();
  }

  /**
   * Viewer for manual.
   */
  public viewManual(): void {
    this._document = { fileExtension: '.pdf', title: 'Manual de uso', manual: true };
    this._isOpen = true;
    this._bodyService.blockBody();
  }

  /**
   * Event handler to close viewer.
   */
  public close(): void {
    this._isClosing = true;
    setTimeout(() => {
      this._isOpen = false;
      this._isClosing = false;
      this._document = undefined;
      this._bodyService.unlockBody();
    }, 1000);
  }
}